export module ProvidersEnumerations {
    export class EnumerationModel {
        constructor(public code: string, public name: string) {}
    }

    export class Gender {
        static readonly female = new EnumerationModel('Female', 'Female');
        static readonly male = new EnumerationModel('Male', 'Male');
        static readonly other = new EnumerationModel('Other', 'Other');
    }

    export class ProfileDataStatus {
        static readonly pending = new EnumerationModel('Pending', 'Pending');
        static readonly approved = new EnumerationModel('Approved', 'Approved');
        static readonly rejected = new EnumerationModel('Rejected', 'Rejected');
        static readonly archived = new EnumerationModel('Archived', 'Archived');
    }

    export class ProviderStatus {
        static readonly active = new EnumerationModel('Active', 'Active');
        static readonly inactive = new EnumerationModel('Inactive', 'Inactive');
    }
}
